import { createSelector } from 'reselect'

const getFullNews = ({ news }) => news.full
const getCurrentId = (state, { articleId }) => articleId

export const getFullArticle = () => createSelector(
  [ getFullNews, getCurrentId ],
  (items = {}, articleId) => (articleId && items[articleId]) ? items[articleId] : null
)



// WEBPACK FOOTER //
// ./src/selectors/news.js